export const ACTIVITIES_HISTORY = 1
export const SHARED_NOTES_HISTORY = 2
export const COMMENTS_HISTORY = 3
export const TASKS_HISTORY = 4
